import React from 'react';
import { Router } from 'react-router-dom';

import ContentArea from '../ContentArea';
import history from '../../utils/history';

export default () => {
  return (
    <React.Fragment>
      <Router history={history}>
        <ContentArea />
      </Router>
    </React.Fragment>
  );
};
